export const modalDarkBlueColors = {
  background: '#16191F',
  modalCard: 'rgba(255, 255, 255, 0.03)',
  stroke: 'rgba(84, 84, 86, 0.60)',
  titleText: '#fff',
  textSecondary: 'rgba(235, 235, 245, 0.60)',
}
